/*
 * Montrelio (19.10.2026) : la pastille du panier ne compte pas l'écrin offert.
 * Après un ajout, le thème réécrit la pastille avec le total Shopify (écrin inclus).
 * On observe la pastille et on la corrige à partir de /cart.js (écrin à 0 € retiré du compte).
 * Le rendu serveur (montrelio-cart-count.liquid) est déjà juste au chargement.
 */
(function () {
  if (window.__mEcrinCount) return;
  window.__mEcrinCount = true;

  var busy = false;
  var timer = null;

  function freeEcrinQty(cart) {
    return (cart.items || []).reduce(function (n, it) {
      return it.handle === 'ecrin-montrelio' && it.final_line_price === 0 ? n + it.quantity : n;
    }, 0);
  }

  function fix() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = cart.item_count - freeEcrinQty(cart);
        document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) {
          var want = n > 99 ? '' : String(n);
          if (el.textContent.trim() !== want) el.textContent = want;
        });
      })
      .catch(function () {})
      .then(function () { setTimeout(function () { busy = false; }, 300); });
  }

  function soon() {
    clearTimeout(timer);
    timer = setTimeout(fix, 250);
  }

  // La pastille est réécrite par le thème (et réinjectée par le morph) : on surveille tout le document,
  // mais on n'agit que si une pastille a changé.
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      var el = t.nodeType === 3 ? t.parentElement : t;
      if (el && el.closest && el.closest('.cart-bubble')) { soon(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  // L'écrin est ajouté par la réconciliation environ 1 à 2 s après la montre : on revérifie un peu après.
  document.addEventListener('cart:update', function () { soon(); setTimeout(fix, 2500); });
})();
